import React from 'react';
import PropTypes from 'prop-types';

const Navigate = ({
    href = "/",
    children, 
    variant = 'primary', 
    alternate = false,
    active = false,
    size = 'medium',
    disabled = false,
    icon = null,
    newTab = false,
    unsetHeight = false,
    unsetPadding = false,
    darkMode = false,
    flexGrow = null,
    stretch = false,
    classes = "",
    index = null,
    style = {},
    ...props 
}) => (
    <a
        key={index}
        href={href}
        className={`anchor figtree-bold ${!children ? "icon-only" : ""} ${variant} ${alternate ? "alternate" : ""} ${active ? "active" : ""} ${disabled ? "disabled" : ""} ${size} ${unsetHeight ? "unset-height" : ""} ${unsetPadding ? "unset-padding" : ""} ${stretch ? "stretch" : ""} ${darkMode ? "dark-mode" : ""} ${children ? "text" : ""} ${children ? (size === "small" ? "caption" : size === "medium" ? "caption" : size === "large" ? "paragraph" : "") : ""} ${classes}`} {...props}
        target={newTab ? "_blank" : "_self"}
        rel={newTab ? "noopener noreferrer" : ""}
        style={{
            flexGrow: flexGrow,
            ...style
        }}
    >
        {children}
        {icon && (
            <div className={`icon ${icon}`} />
        )}
    </a>
);

Navigate.propTypes = {
    href: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary', 'white', 'yellow', 'black', 'transparent', 'text']),
    alternate: PropTypes.bool,
    active: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    icon: PropTypes.string,
    unsetHeight: PropTypes.bool,
    unsetPadding: PropTypes.bool,
    darkMode: PropTypes.bool,
    flexGrow: PropTypes.number,
    classes: PropTypes.string,
    index: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.node
};

export default Navigate;